<script>

    import BlockEditor from "../../../../../../../js/common/canvas/editor/canvas/document/editors/BlockEditor";

    export default {

        extends: BlockEditor,

        created()
        {
            this.disableNavigating();

            // TODO Enable later. Disabled because the panel is in front of the editable text.
            // this.initEditing();
        },

        methods: {

            // TODO Start code duplication with utils/line.
            initEditing()
            {
                this.element
                    .blur(this.onBlur)
                    .keydown(this.onKeyDown);

                this.manageEditing();
            },

            manageEditing()
            {
                this.element
                    .attr('contenteditable', this.blockSelectionEnabled);
            },

            onKeyDown()
            {
                // Prevent due to is saving thus we will loose the text soon it reloads the HTML.
                if(this.pageState.saving)
                    return false;
            },

            onBlur()
            {
                // Set
                this.$set(this.canvasBlock.options, 'text', this.element.text());
            },

            disableNavigating()
            {
                this.element
                    .click(() => false)
            },

        },

        watch: {

            'blockSelectionEnabled'()
            {
                this.manageEditing();
            },

        }

    }

</script>